import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TableHeader from '../../../shared/Table/TableHeader';
import TableContainer from '../../../shared/TableContainer';
import CreditUsageListColumns from '../CreditUsageListColumns';
import Pagination from '../../../shared/Table/Pagination/Pagination';
import { sliceToPages } from '../../../../utility/functions/sliceToPages';
import { UsageListItem } from '../../../../store/CreditsManagement/creditsManagementTypes';

interface CreditUsageListTableProps {
  usageList: UsageListItem[];
}

const CreditUsageListTable = (props: CreditUsageListTableProps) => {
  const { t } = useTranslation();
  const rowPerPageOptions = [10, 25, 50];
  const [activePage, setActivePage] = useState(1);
  const [creditsUsageList, setCreditsUsageList] = useState<any[]>([]);
  const [rowsPerPage, setRowsPerPage] = useState(rowPerPageOptions[0]);

  useEffect(() => {
    const usageList: any[] = [];

    props.usageList.forEach((usage) => {
      usage.payments.forEach((payment) => {
        if (payment.creditAmount > 0 || payment.creditAmount < 0) {
          const newUsage = {
            name: usage.name,
            amount: payment.creditAmount,
            orderedBy: usage.orderedBy.fullName,
            isRefund: payment.paymentStatus === 'refund',
            date: usage.item?.startTime || '',
            fromDate: usage.item?.startTime,
            toDate: usage.item?.endTime,
          };
          usageList.push(newUsage);
        }
      });
    });
    setCreditsUsageList(usageList);
  }, [props.usageList]);

  const CustomPagination = () => {
    return (
      <Pagination
        pagesCount={Math.ceil(creditsUsageList.length / rowsPerPage)}
        onPageChange={setActivePage}
        activePage={activePage - 1}
      />
    );
  };

  const CustomHeader = () => {
    return (
      <TableHeader
        rowsPerPage={rowsPerPage}
        rowsOptions={rowPerPageOptions}
        onChange={setRowsPerPage}
      />
    );
  };

  return (
    <div className="credits-usage-list-table">
      <TableContainer
        data={sliceToPages(creditsUsageList, activePage, rowsPerPage)}
        columns={CreditUsageListColumns(t)}
        pagination={CustomPagination}
        header={CustomHeader}
      />
    </div>
  );
};

export default CreditUsageListTable;
